module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-21@2x-2ec97a54e9c3317bb54bb3cc076a91df.png";